module.exports = __webpack_public_path__ + "img/shouye_youhui@2x.df720923.png";